import { environment } from "../../environments/environment";

export class Config {

    /**
     * Nome da aplicação.
     */
    public applicationName = 'Target IT'

    /**
     * Nome encurtado da aplicação.
     */
    public applicationNameShort = 'T'

    /**
     * URL da API do backend.
     */
    private urlServiceBackend = `${environment['APP_URL']}/api/`

    /**
     * URL do backend.
     */
    private urlBackend = `${environment['APP_URL']}/`

    /**
     * Host de acesso ao serviço web Socket auto hospedado
     */
    private socketHost = environment['SOCKET_HOST']

    /**
     * Porta de acesso ao serviço web Socket auto hospedado
     */
    private socketPort = environment['SOCKET_PORT']

    /**
     * Porta de acesso ao serviço web Socket auto hospedado
     */
    private clientId = environment['APP_HUB_CLIENT_ID']

    private clientSecret = environment['APP_HUB_CLIENT_SECRET']

    public get(name:string): any {
        return this[name] == undefined ? null : this[name];
    }
}
